import apollo from '@/graphql'

import PaginatedAuditsQuery from '@/graphql/audit/PaginatedAuditsQuery.gql'
import ScIssueTypesQuery from '@/graphql/audit/ScIssueTypesQuery.gql'
import ScUnresolvedReasonsQuery from '@/graphql/audit/ScUnresolvedReasonsQuery.gql'

// initial state
const state = {
  isAuditListLoading: false,
  paginatedAudits: {},
  scIssueTypes: [],
  scUnresolvedReasons: [],
}

// getters
const getters = {
  isAuditListLoading: st => st.isAuditListLoading,
  paginatedAudits: st => st.paginatedAudits,
  scIssueTypes: st => st.scIssueTypes,
  scUnresolvedReasons: st => st.scUnresolvedReasons,
}

// mutations
const mutations = {
  setPaginatedAudits(st, paginatedAudits) {
    state.paginatedAudits = paginatedAudits
  },

  setScIssueTypes(st, scIssueTypes) {
    state.scIssueTypes = scIssueTypes
  },

  setScUnresolvedReasons(st, scUnresolvedReasons) {
    state.scUnresolvedReasons = scUnresolvedReasons
  },
}

// actions
const actions = {
  loadAudits({ commit }, { doLoading, variables }) {
    state.isAuditListLoading = doLoading

    return apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      // pollInterval: 10000, // don't use this - it will create compounding queries when searching
      query: PaginatedAuditsQuery,
      variables,
    }).subscribe(({ data: { paginatedAudits } }) => {
      state.isAuditListLoading = false
      commit('setPaginatedAudits', paginatedAudits)
    })
  },

  loadScIssueTypes({ commit }) {
    apollo.defaultClient.watchQuery({
      query: ScIssueTypesQuery,
    }).subscribe(({ data: { scIssueTypes } }) => {
      commit('setScIssueTypes', scIssueTypes)
    })
  },

  loadScUnresolvedReasons({ commit }) {
    apollo.defaultClient.watchQuery({
      query: ScUnresolvedReasonsQuery,
    }).subscribe(({ data: { scUnresolvedReasons } }) => {
      commit('setScUnresolvedReasons', scUnresolvedReasons)
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/audit/AuditList.js